import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
/**
 * 前端路由
 */
export const locRoutes = [{
  name: 'workplaceaa',
  key: 'admin/dashboard/workplaceaa',
  page: 'demo/dashboard/workplace'
}];
export const routes = [{
  name: 'menu.dashboard',
  key: 'admin/dashboard',
  page: 'dashboard',
  children: [{
    name: 'menu.dashboard.workplace',
    key: 'admin/dashboard/workplace',
    page: 'demo/dashboard/workplace'
  }, {
    name: 'menu.dashboard.monitor',
    key: 'admin/dashboard/monitor',
    page: 'demo/dashboard/workplace',
    requiredPermissions: [{
      resource: 'menu.dashboard.monitor',
      actions: ['write']
    }]
  }]
}, {
  name: 'menu.system',
  key: 'admin/system',
  page: 'system',
  children: [{
    name: 'menu.system.menu',
    key: 'admin/system/menu',
    page: 'system/menu'
  }]
}, {
  name: 'menu.visualization',
  key: 'admin/visualization',
  page: 'visualization',
  children: [{
    name: 'menu.visualization.dataAnalysis',
    key: 'admin/visualization/data-analysis',
    page: 'demo/visualization/data-analysis',
    requiredPermissions: [{
      resource: 'menu.visualization.dataAnalysis',
      actions: ['read']
    }]
  }, {
    name: 'menu.visualization.multiDimensionDataAnalysis',
    key: 'admin/visualization/multi-dimension-data-analysis',
    page: 'demo/visualization/multi-dimension-data-analysis',
    requiredPermissions: [{
      resource: 'menu.visualization.dataAnalysis',
      actions: ['read', 'write']
    }, {
      resource: 'menu.visualization.multiDimensionDataAnalysis',
      actions: ['write']
    }],
    oneOfPerm: true
  }]
}, {
  name: 'menu.list',
  key: 'admin/list',
  page: 'list',
  children: [{
    name: 'menu.list.searchTable',
    key: 'admin/list/search-table',
    page: 'demo/list/search-table'
  }, {
    name: 'menu.list.cardList',
    key: 'admin/list/card',
    page: 'demo/list/card'
  }]
}, {
  name: 'menu.form',
  key: 'admin/form',
  page: 'form',
  children: [{
    name: 'menu.form.group',
    key: 'admin/form/group',
    page: 'demo/form/group',
    requiredPermissions: [{
      resource: 'menu.form.group',
      actions: ['read', 'write']
    }]
  }, {
    name: 'menu.form.step',
    key: 'admin/form/step',
    page: 'demo/form/step',
    requiredPermissions: [{
      resource: 'menu.form.step',
      actions: ['read']
    }]
  }]
}, {
  name: 'menu.profile',
  key: 'admin/profile',
  page: 'profile',
  children: [{
    name: 'menu.profile.basic',
    key: 'admin/profile/basic',
    page: 'demo/profile/basic'
  }]
}, {
  name: 'menu.result',
  key: 'admin/result',
  page: 'result',
  children: [{
    name: 'menu.result.success',
    key: 'admin/result/success',
    page: 'demo/result/success',
    breadcrumb: false
  }, {
    name: 'menu.result.error',
    key: 'admin/result/error',
    page: 'demo/result/error',
    breadcrumb: false
  }]
}, {
  name: 'menu.exception',
  key: 'admin/exception',
  page: 'exception',
  children: [{
    name: 'menu.exception.403',
    key: 'admin/exception/403',
    page: 'exception/403'
  }, {
    name: 'menu.exception.404',
    key: 'admin/exception/404',
    page: 'exception/404'
  }, {
    name: 'menu.exception.500',
    key: 'exception/500',
    page: 'exception/500'
  }]
}, {
  name: 'menu.user',
  key: 'admin/user',
  page: 'user',
  children: [{
    name: 'menu.user.info',
    key: 'admin/user/info',
    page: 'demo/user/info'
  }, {
    name: 'menu.user.setting',
    key: 'admin/user/setting',
    page: 'demo/user/setting'
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};
const renderMenu = (menus, routes) => {
  for (const menu of menus) {
    const newRoute = {
      name: menu.menu_name,
      key: menu.menu_url,
      page: menu.menu_path,
      icon: menu.menu_icon,
      breadcrumb: menu.menu_breadcrumb === 1,
      ignore: menu.menu_ignore === 1,
      requiredPermissions: [{
        resource: menu.menu_key,
        actions: ['read']
      }]
    };
    if (menu.children) {
      newRoute['children'] = [];
      renderMenu(menu.children, newRoute['children']);
    }
    routes.push(newRoute);
  }
};
const renderLocRoute = (menus, routes) => {
  for (const menu of menus) {
    const newRoute = {
      name: menu.name,
      key: menu.key,
      page: menu.page,
      breadcrumb: false,
      ignore: true
    };
    if (menu.children) {
      newRoute['children'] = [];
      renderMenu(menu.children, newRoute['children']);
    }
    routes.push(newRoute);
  }
};
const useRoute = (userPermission, userType, menuInfo) => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission, userType);
      }
      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = {
          ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({
          ...route
        });
      }
    }
    return arr;
  };
  const [permissionRoute, setPermissionRoute] = useState([]); // routes
  // const [permissionRoute, setPermissionRoute] = useState(routes);  // 本地目录，已弃用
  useEffect(() => {
    const routes = [];
    if (menuInfo) {
      renderMenu(menuInfo, routes);
      // renderLocRoute(locRoutes, routes); // 本地目录，已弃用

      const newRoutes = filterRoute(routes);
      setPermissionRoute(newRoutes);
    }
  }, [JSON.stringify(userPermission), menuInfo]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};
export default useRoute;